// extracted by mini-css-extract-plugin
export default {"container":"LocationDetailPage_container__4M637","content":"LocationDetailPage_content__Ibl0d"};